import { JsonObject, JsonProperty } from 'typescript-json-serializer';

export enum VISUALISATION_FEATURES {
    AREA = 'VISUALISATION_TOOL_ANALYTICS_AREA',
    STACKED_LINE = 'VISUALISATION_TOOL_ANALYTICS_STACKED_AREAS',
    HEATMAP = 'VISUALISATION_TOOL_ANALYTICS_HEATMAP',
    MULTI_DEVICE_HEATMAP = 'VISUALISATION_TOOL_ANALYTICS_MULTI_DEVICE_HEATMAP',
    SCATTER_PLOT = 'VISUALISATION_TOOL_ANALYTICS_SCATTER_PLOT',
    AGGREGATED_COLUMNS = 'VISUALISATION_TOOL_ANALYTICS_AGGREGATED_COLUMNS',
    STATISTICS = 'VISUALISATION_TOOL_ANALYTICS_STATISTICS',
    AI_GENERATED_TEXT = 'VISUALISATION_TOOL_ANALYTICS_AI_GENERATED_TEXT',
    INDEPENDENT_CONFIGURATION = 'VISUALISATION_TOOL_ANALYTICS_INDEPENDENT_CONFIGURATION',
}

@JsonObject()
class LicensePermissions {
    constructor(@JsonProperty({ required: true }) readonly features: LicensePermissionFeature[]) {}
}

export enum FEATURES_ACCCESS {
    YES = 'YES',
    NO = 'NO',
    REDIRECT = 'REDIRECT',
}
@JsonObject()
export class LicensePermissionFeature {
    constructor(
        @JsonProperty({ required: true }) readonly access: FEATURES_ACCCESS,
        @JsonProperty({ required: true }) readonly name: string,
        @JsonProperty({ required: true }) readonly redirectUrl: string
    ) {}
}

export default LicensePermissions;
